import { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import CheckIcon from "@material-ui/icons/Check";
import SignaturePad from "./SignaturePad";

export default function SignatureDialog({ signature, setSignature, name }) {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSetSignature = (signature) => {
    setOpen(false);
    setSignature(signature);
  };

  return (
    <div>
      <Button
        size="small"
        startIcon={signature ? <CheckIcon /> : <BorderColorIcon />}
        variant="outlined"
        color="primary"
        onClick={handleClickOpen}>
        Firma del Cliente
      </Button>

      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
        <DialogContent>
          <SignaturePad setSignature={handleSetSignature} name={name} />
        </DialogContent>
      </Dialog>
    </div>
  );
}
